import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { BackLink } from '@/components/shared/BackLink'
import { ArchivesPageMain } from '@/components/shared/page/ArchivesPageMain'
import { CookiePolicyArchivesPageRecord, CookiePolicyRecord } from '@/graphql/CookiePolicy'
import Head from 'next/head'
import { useMemo } from 'react'
import { StructuredText } from 'react-datocms'
import { theme } from 'styles/theme'
import { ArchivedCookiePolicy, ArchivedCookiePolicyList } from './ArchivedCookiePolicyList'

type CookiePolicyArchivesPageProps = {
  page: CookiePolicyArchivesPageRecord
  archivedCookiePolicies: CookiePolicyRecord[]
}

export const CookiePolicyArchivesPage = ({ page, archivedCookiePolicies = [] }: CookiePolicyArchivesPageProps) => {
  const cookiePolicyForCountry = useMemo<ArchivedCookiePolicy[]>(() => {
    return archivedCookiePolicies.map((p) => ({
      url: p.pageSlug,
      effectiveFrom: p.effectiveFrom,
    }))
  }, [archivedCookiePolicies])

  return (
    <>
      <Head>
        <title>ZOE Cookie Policy Archives</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="canonical" href={`${process.env.SITE_URL}/cookie-policy/archives`} />
      </Head>

      <Header backgroundColor={theme.v2.surface.white} />

      <ArchivesPageMain>
        <h2>{page.pageName}</h2>

        <BackLink href="/cookie-policy">Current Cookie Policy</BackLink>

        <StructuredText data={page.pageContent} />

        <ArchivedCookiePolicyList archivedCookiePolicy={cookiePolicyForCountry} />
      </ArchivesPageMain>

      <Footer />
    </>
  )
}
